import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentQualificates } from 'src/app/model/equipment';
import { GenericClass } from 'src/app/model/genericClass';
import { EquipmentTypeQualificatesService } from 'src/app/services/equipmentTypeQualificates.service';
import { QualificationUtils } from '../../../../utils/qualificationUtils';
import { EquipmentTypeQualificationEnum } from 'src/app/model/equipmentType';
import { GenericClassTranslate } from '../../../../model/genericClass';

export interface DialogDataEquipment {
  equipment: EquipmentQualificates;
  isEdit: boolean;
  isOnlyPQ: boolean;
}

@Component({
    selector: 'app-protocol-q-edit-equipment-dialog',
    templateUrl: './protocol-q-edit-equipment-dialog.component.html',
    standalone: false,
})
export class ProtocolEditEquipmentDialogComponent implements OnInit {

  mappingTypes = [{value: 'summer'}, {value: 'winter'}];
  allowedSummerWinter = [EquipmentTypeQualificationEnum.WAREHOUSE, EquipmentTypeQualificationEnum.VEHICLE]
  tituloDialog: string;
  form: FormGroup;
  
  equipmentTypes: GenericClassTranslate[];

  constructor(
    fb: FormBuilder,
    private translate: TranslateService,
    private equipmentTypeQualificatesService: EquipmentTypeQualificatesService,
    private dialogRef: MatDialogRef<ProtocolEditEquipmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataEquipment
  ) {
    if (data.isEdit) {
      // eslint-disable-next-line max-len
      this.tituloDialog = this.translate.instant('protocolEdit.dialog.equipment.title.edit', { name: !data.equipment.serialNumber ? data.equipment.equipment : data.equipment.serialNumber }) as string;
    } else {
      this.tituloDialog = this.translate.instant('protocolEdit.dialog.equipment.title.create') as string;
    }

    this.form = fb.group({
      equipment: [this.data.equipment, [Validators.required]],
      maker: [this.data.equipment.maker],
      model: [this.data.equipment.model],
      serialNum: [this.data.equipment.serialNumber],
      idType: [this.data.equipment.idType, [Validators.required]],
      rotorSerial: [this.data.equipment.rotorSerial],
      rotorModel: [this.data.equipment.rotorModel],
      location: [this.data.equipment.location, [Validators.required]],
      internalId: [this.data.equipment.internalId],
      mappingType: [this.data.equipment.mappingType]
    });
    this.equipmentTypeQualificatesService.findAll().subscribe((res: GenericClassTranslate[]) => {
      this.equipmentTypes = res;
    });
  }

  ngOnInit(): void {
    if (!this.data.equipment.idType) {
      this.data.equipment.idType = EquipmentTypeQualificationEnum.EQUIPMENT_TYPE;
    }
  }

  onOkClick(): void {
    if (this.form.valid) {
      this.data.equipment.nameType = this.equipmentTypes.find(e => e.id === this.data.equipment.idType)?.translation;
      this.dialogRef.close(this.data.equipment);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showEquipmentAllowed(): boolean {
    return this.allowedSummerWinter.includes(this.data.equipment.idType) && this.data.isOnlyPQ;
  }

  showIsCentrifuge(): boolean {
    return EquipmentTypeQualificationEnum.CENTRIFUGE === this.data.equipment?.idType;

  }
}
